export const environment = {
    production: true
};
export const WEB_URL = "https://privatelendingstrategies.com"
export const SERVER_URL = 'https://privatebankapp.com/api';
export const SUPERTOKEN_URL = "https://privatebankapp.com"
